export class CsvExport {
  public static downloadCSV(csv: string, filename: string) {
    let csvFile;
    let downloadLink;

    // CSV file
    csvFile = new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf8;' });

    // Download link
    downloadLink = document.createElement('a');

    // Set ID on download link, mostly for test
    downloadLink.setAttribute('class', 'csv-download-link');

    // File name
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);

    // Click download link
    downloadLink.click();

  }
}
